




















import { computed, defineComponent, PropType } from "@vue/composition-api";
import { AiUserQuestionary } from "@scrile/api-provider/dist/projects/scrileConnect/AiUserQuestionaryProvider";
import PageTitle from "@/components/PageTitle";
import { fields } from "../../config";
import AiQuestionaryBlock from "../AiQuestionaryBlock";
import AiResponseSetting from "../AiResponseSetting";

export default defineComponent({
  name: "AiQuestionaryView",
  components: { AiResponseSetting, AiQuestionaryBlock, PageTitle },
  props: {
    values: { type: Object as PropType<AiUserQuestionary["fields"]> },
    aiResponseEnabled: { type: Boolean, default: false },
    nsfwEnabled: { type: Boolean, required: true },
  },
  setup(props) {
    const availableFields = computed(() => {
      if (!props.nsfwEnabled) {
        const { nsfw, ...rest } = fields;
        return rest;
      }
      return fields;
    });
    return {
      availableFields,
    };
  },
});
